export enum ContentfulPageSectionTemplate {
  TWO_COLS = 'two-cols',
  THREE_COLS = 'three-cols',
  FOUR_COLS = 'four-cols',
  RECOMMENDATION = 'recommendation',
  ACCORDION = 'accordion',
  OFFER = 'offer',
  CAROUSEL = 'carousel',
  BENTO = 'refresh-bento',
  IMAGE_LEFT = 'refresh-image-left',
  PICTO_RIGHT = 'refresh-picto-right',
  STARS = 'stars',
  STAGE = 'etapier',
  TABS = 'tabs',
  DEFAULT = 'default',
}

export enum ContentfulPageSectionStyle {
  DEFAULT = 'default',
  FILIGRANE_LEFT = 'filigrane-left',
  FILIGRANE_RIGHT = 'filigrane-right',
  REFRESH_WHITE_BACKGROUND = 'refresh-fond-blanc',
  REFRESH_GREY_BACKGROUND = 'refresh-fond-gris',
  REFRESH_BLUE_BACKGROUND = 'refresh-fond-bleu',
  REFRESH_GRADIENT_BACKGROUND = 'refresh-fond-gradient',
  PREMIUM_BLACK = 'noir-premium',
  ICONIC_1 = 'iconic-1',
  ICONIC_2 = 'iconic-2',
}
